// ============================================
// HEADER COMPONENT - Extrait de App.js
// Extraction: Étape 1 - Découpage monolithe
// Behavior: INCHANGÉ
// ============================================
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Header = ({ 
  showContactsView,
  showDemandesContactView,
  showFavoritesView,
  favoriteProperties = [],
  showDashboardView,
  showDocumentsView,
  showMarketingView,
  showPropertiesView,
  showOutilsView,
  setActiveMarketingTab,
  setActiveOutilsTab,
  setActiveDocumentsTab,
  startNewContact, 
  startNewProperty, 
  setShowContacts, 
  setShowForm, 
  setContactSearchFilters, 
  loadProperties,
  globalSearch,
  setGlobalSearch,
  handleSearchFilterChange,
  executeSearch,
  activeDropdown,
  setActiveDropdown,
  userProfile,
  activeSection,
  setActiveSection
}) => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [mobileSubMenu, setMobileSubMenu] = useState(null);

  return (
    <header className="relative z-50 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 shadow-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          
          {/* Logo Section - KOMERCES plus grand */}
          <div className="flex items-center cursor-pointer hover:opacity-80 transition-opacity" onClick={showDashboardView}>
            <img 
              src="/new_logo_komerces_transparent.webp" 
              alt="KOMERCES Logo" 
              className="h-20 w-auto object-contain"
            />
          </div>

          {/* Center - Search + Service Icons */}
          <div className="hidden lg:flex items-center space-x-6">
            {/* Global Search Bar - Simplifié */}
            <div className="flex items-center bg-white/10 rounded-lg px-4 py-2 min-w-80">
              <i className="bi bi-search text-white/60 mr-3"></i>
              <input
                type="text"
                value={globalSearch}
                onChange={(e) => setGlobalSearch(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleSearchFilterChange('libre', globalSearch);
                    executeSearch();
                  }
                }}
                placeholder="Recherche globale..."
                className="bg-transparent text-white placeholder-white/50 text-sm outline-none flex-1"
              />
              {globalSearch && (
                <button
                  onClick={() => {
                    setGlobalSearch('');
                    handleSearchFilterChange('libre', '');
                  }}
                  className="text-white/60 hover:text-red-400 ml-2"
                >
                  <i className="bi bi-x-circle"></i>
                </button>
              )}
            </div>

            {/* Service Icons - Avec couleurs distinctives */}
            <div className="flex items-center space-x-4">
              <button className="relative text-blue-400 hover:text-blue-300 transition-colors p-2" title="Messagerie">
                <i className="bi bi-envelope text-xl"></i>
                <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
              </button>
              
              <button className="relative text-emerald-400 hover:text-emerald-300 transition-colors p-2" title="Tâches">
                <i className="bi bi-check2-square text-xl"></i>
                <span className="absolute top-0 right-0 w-2 h-2 bg-emerald-500 rounded-full"></span>
              </button>
              
              <button className="relative text-orange-400 hover:text-orange-300 transition-colors p-2" title="Agenda">
                <i className="bi bi-calendar3 text-xl"></i>
              </button>
              
              <button 
                onClick={showContactsView}
                className="relative text-slate-300 hover:text-white transition-colors p-2" 
                title="Contacts"
              >
                <i className="bi bi-people text-xl"></i>
              </button>
              
              <button 
                onClick={showFavoritesView}
                className="relative text-pink-400 hover:text-pink-300 transition-colors p-2" 
                title="Favoris"
              >
                <i className={`bi ${favoriteProperties.length > 0 ? 'bi-heart-fill' : 'bi-heart'} text-xl`}></i>
                {favoriteProperties.length > 0 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-pink-500 text-white text-xs rounded-full flex items-center justify-center font-bold">
                    {favoriteProperties.length}
                  </span>
                )}
              </button>
              
              <button className="relative text-red-400 hover:text-red-300 transition-colors p-2" title="Notifications">
                <i className="bi bi-bell text-xl"></i>
                <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
              </button>
            </div>
          </div>

          {/* Right - User Profile */}
          <div className="flex items-center space-x-4">
            {/* User Profile - Corrigé pour Safari */}
            <div className="relative">
              <div 
                className="flex items-center space-x-3 cursor-pointer"
                onClick={() => setActiveDropdown(activeDropdown === 'profile' ? null : 'profile')}
              >
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold shadow-lg">
                  {userProfile?.firstName?.charAt(0) || 'Y'}
                </div>
                <div className="hidden lg:block text-right">
                  <div className="text-white font-medium text-sm">
                    {userProfile?.firstName || 'Yvan'} {userProfile?.lastName || 'GRIMAZ'}
                  </div>
                  <div className="text-white/60 text-xs">
                    KOMERCES
                  </div>
                </div>
                <i className={`bi bi-chevron-down text-white/60 text-sm hidden lg:block transition-transform duration-200 ${activeDropdown === 'profile' ? 'rotate-180' : ''}`}></i>
              </div>
              
              {/* Profile dropdown - Z-index Safari-compatible */}
              {activeDropdown === 'profile' && (
                <div className="absolute right-0 top-full mt-2 w-64 bg-white rounded-lg shadow-xl border z-[9999]">
                  <div className="p-4">
                    <div className="text-gray-900 font-medium mb-4">Profil & Paramètres</div>
                    <div className="space-y-2">
                      <button className="w-full text-left text-gray-700 hover:text-gray-900 py-2 px-3 rounded hover:bg-gray-100 transition-colors text-sm">
                        <i className="bi bi-person-circle mr-2"></i>Mon profil
                      </button>
                      <button className="w-full text-left text-gray-700 hover:text-gray-900 py-2 px-3 rounded hover:bg-gray-100 transition-colors text-sm">
                        <i className="bi bi-gear mr-2"></i>Paramètres
                      </button>
                      <hr className="my-2" />
                      <button className="w-full text-left text-red-600 hover:text-red-800 py-2 px-3 rounded hover:bg-red-50 transition-colors text-sm">
                        <i className="bi bi-box-arrow-right mr-2"></i>Déconnexion
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Mobile menu button */}
            <button 
              className="lg:hidden text-white p-2"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={`bi ${isMobileMenuOpen ? 'bi-x-lg' : 'bi-list'} text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Main Navigation Menu - Simplifié */}
        <div className="border-t border-white/10 py-3">
          <nav className="flex items-center justify-between">
            {/* Left Navigation - Menus avec onClick pour Safari */}
            <div className="hidden lg:flex items-center space-x-6">
              {[
                { 
                  label: 'Biens', 
                  icon: 'bi-buildings',
                  items: ['Liste des biens', 'Nouveau bien', 'Modifier/Consulter', 'Recherche avancée'],
                  key: 'biens'
                },
                { 
                  label: 'Acquéreurs', 
                  icon: 'bi-people',
                  items: ['Annuaire complet', 'Nouveau contact', 'Recherche contacts', 'Demandes de contact', 'Import/Export'],
                  key: 'contacts'
                },
                { 
                  label: 'Documents & Diffusion', 
                  icon: 'bi-file-earmark-pdf',
                  items: ['Mes documents', 'Documents légaux', 'Rapports de visite', 'Diffusion & publications'],
                  key: 'documents'
                },
                { 
                  label: 'Marketing', 
                  icon: 'bi-megaphone',
                  items: ['Dashboard', 'Réseaux sociaux', 'Campagnes', 'Analytics', 'Chatbot'],
                  key: 'marketing'
                },
                { 
                  label: 'Outils', 
                  icon: 'bi-tools',
                  items: ['Calculatrices', 'Statistiques', 'Rapports', 'Exports'],
                  key: 'outils'
                },
                { 
                  label: 'Aide', 
                  icon: 'bi-question-circle',
                  items: ['Documentation', 'Tutoriels', 'Support technique', 'Contact'],
                  key: 'aide'
                }
              ].map((item) => (
                <div 
                  key={item.key}
                  className="relative"
                >
                  <button 
                    className={`flex items-center space-x-2 px-3 py-2 text-white/80 hover:text-white transition-colors ${activeSection === item.key ? 'text-white' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setActiveDropdown(activeDropdown === item.key ? null : item.key);
                    }}
                  >
                    <i className={`${item.icon}`}></i>
                    <span className="font-medium text-sm">{item.label}</span>
                    <i className={`bi bi-chevron-down text-xs transition-transform duration-200 ${activeDropdown === item.key ? 'rotate-180' : ''}`}></i>
                  </button>

                  {/* Dropdown - Repositionné pour Safari */}
                  {activeDropdown === item.key && (
                    <div 
                      className="absolute top-full left-0 mt-1 w-56 bg-white rounded-lg shadow-xl border z-[99999]" 
                      style={{zIndex: 99999}}
                      onMouseEnter={(e) => {
                        e.stopPropagation();
                        // Keep dropdown open when hovering over it
                      }}
                      onMouseLeave={(e) => {
                        e.stopPropagation();
                        // Add delay before closing
                        setTimeout(() => {
                          if (activeDropdown === item.key) {
                            setActiveDropdown(null);
                          }
                        }, 300);
                      }}
                    >
                      <div className="py-2">
                        {item.items.map((subItem, index) => (
                          <button
                            key={index}
                            className="w-full text-left text-gray-700 hover:text-gray-900 hover:bg-gray-100 py-2 px-4 transition-colors text-sm"
                            onClick={() => {
                              // BIENS
                              if (item.key === 'biens' && subItem === 'Liste des biens') {
                                showPropertiesView();
                                setActiveDropdown(null);
                              } else if (item.key === 'biens' && subItem === 'Nouveau bien') {
                                startNewProperty();
                                setActiveDropdown(null);
                              } else if (item.key === 'biens' && subItem === 'Modifier/Consulter') {
                                showPropertiesView();
                                setActiveDropdown(null);
                              } else if (item.key === 'biens' && subItem === 'Recherche avancée') {
                                showPropertiesView();
                                setActiveDropdown(null);
                              }
                              
                              // CONTACTS/ACQUÉREURS  
                              else if (item.key === 'contacts' && subItem === 'Annuaire complet') {
                                showContactsView();
                                setActiveDropdown(null);
                              } else if (item.key === 'contacts' && subItem === 'Nouveau contact') {
                                startNewContact();
                                setActiveDropdown(null);
                              } else if (item.key === 'contacts' && subItem === 'Recherche contacts') {
                                showContactsView();
                                setActiveDropdown(null);
                              } else if (item.key === 'contacts' && subItem === 'Demandes de contact') {
                                showDemandesContactView();
                                setActiveDropdown(null);
                              } else if (item.key === 'contacts' && subItem === 'Import/Export') {
                                showContactsView();
                                setActiveDropdown(null);
                              }
                              
                              // DOCUMENTS & DIFFUSION - Navigation vers routes
                              else if (item.key === 'documents' && subItem === 'Mes documents') {
                                navigate('/documents/mes-documents');
                              } else if (item.key === 'documents' && subItem === 'Documents légaux') {
                                navigate('/documents/documents-legaux');
                              } else if (item.key === 'documents' && subItem === 'Rapports de visite') {
                                navigate('/documents/rapports-visite');
                              } else if (item.key === 'documents' && subItem === 'Diffusion & publications') {
                                navigate('/documents/diffusion');
                              } else if (item.key === 'documents') {
                                // Default fallback
                                navigate('/documents/mes-documents');
                              }
                              
                              // MARKETING
                              else if (item.key === 'marketing' && subItem === 'Dashboard') {
                                showMarketingView();
                                setActiveMarketingTab('dashboard');
                                setActiveDropdown(null);
                              } else if (item.key === 'marketing' && subItem === 'Réseaux sociaux') {
                                showMarketingView();
                                setActiveMarketingTab('social');
                                setActiveDropdown(null);
                              } else if (item.key === 'marketing' && subItem === 'Campagnes') {
                                showMarketingView();
                                setActiveMarketingTab('campaigns');
                                setActiveDropdown(null);
                              } else if (item.key === 'marketing' && subItem === 'Analytics') {
                                showMarketingView();
                                setActiveMarketingTab('analytics');
                                setActiveDropdown(null);
                              } else if (item.key === 'marketing' && subItem === 'Chatbot') {
                                showMarketingView();
                                setActiveMarketingTab('chatbot');
                                setActiveDropdown(null);
                              } else if (item.key === 'marketing') {
                                // Default fallback
                                showMarketingView();
                                setActiveMarketingTab('dashboard');
                                setActiveDropdown(null);
                              }
                              
                              // OUTILS
                              else if (item.key === 'outils' && subItem === 'Calculettes') {
                                showOutilsView();
                                setActiveOutilsTab('calculettes');
                                setActiveDropdown(null);
                              } else if (item.key === 'outils' && subItem === 'Statistiques') {
                                showOutilsView();
                                setActiveOutilsTab('statistiques');
                                setActiveDropdown(null);
                              } else if (item.key === 'outils' && subItem === 'Rapports') {
                                showOutilsView();
                                setActiveOutilsTab('rapports');
                                setActiveDropdown(null);
                              } else if (item.key === 'outils') {
                                // Default to dashboard
                                showOutilsView();
                                setActiveOutilsTab('dashboard');
                                setActiveDropdown(null);
                              }
                              
                              // IMPRESSION
                              else if (item.key === 'impression') {
                                showDocumentsView();
                                setActiveDropdown(null);
                              }
                              
                              // AIDE
                              else if (item.key === 'aide' && subItem === 'Documentation') {
                                window.open('https://docs.komerces.com', '_blank');
                                setActiveDropdown(null);
                              } else if (item.key === 'aide' && subItem === 'Support technique') {
                                window.open('mailto:support@komerces.com', '_blank');
                                setActiveDropdown(null);
                              } else if (item.key === 'aide') {
                                setActiveDropdown(null);
                                alert('Aide en développement - Contactez support@komerces.com');
                              }
                            }}
                          >
                            {subItem}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Right side - Status indicators - Simplifiés */}
            <div className="hidden lg:flex items-center space-x-4">
              <div className="flex items-center space-x-2 text-xs text-white/60">
                <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
                <span>Connecté</span>
              </div>
            </div>
          </nav>
        </div>
      </div>
      
      {/* Mobile Menu - Responsive corrigé */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-slate-800/95 backdrop-blur-sm border-t border-white/10 z-50">
          <div className="px-4 py-6">
            {/* Mobile Search */}
            <div className="mb-6">
              <div className="flex items-center bg-white/10 rounded-lg px-4 py-3">
                <i className="bi bi-search text-white/60 mr-3"></i>
                <input
                  type="text"
                  value={globalSearch}
                  onChange={(e) => setGlobalSearch(e.target.value)}
                  placeholder="Recherche..."
                  className="bg-transparent text-white placeholder-white/50 text-sm outline-none flex-1"
                />
              </div>
            </div>

            {/* Mobile Service Icons avec couleurs */}
            <div className="flex justify-around mb-6 py-4 border-y border-white/10">
              <button className="text-blue-400 hover:text-blue-300 transition-colors" title="Messagerie">
                <i className="bi bi-envelope text-2xl"></i>
              </button>
              <button className="text-emerald-400 hover:text-emerald-300 transition-colors" title="Tâches">
                <i className="bi bi-check2-square text-2xl"></i>
              </button>
              <button className="text-orange-400 hover:text-orange-300 transition-colors" title="Agenda">
                <i className="bi bi-calendar3 text-2xl"></i>
              </button>
              <button 
                onClick={showContactsView}
                className="text-slate-300 hover:text-white transition-colors" 
                title="Contacts"
              >
                <i className="bi bi-people text-2xl"></i>
              </button>
              <button 
                onClick={showFavoritesView}
                className="relative text-pink-400 hover:text-pink-300 transition-colors" 
                title="Favoris"
              >
                <i className={`bi ${favoriteProperties.length > 0 ? 'bi-heart-fill' : 'bi-heart'} text-2xl`}></i>
                {favoriteProperties.length > 0 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-pink-500 text-white text-xs rounded-full flex items-center justify-center font-bold">
                    {favoriteProperties.length}
                  </span>
                )}
              </button>
              <button className="text-red-400 hover:text-red-300 transition-colors" title="Notifications">
                <i className="bi bi-bell text-2xl"></i>
              </button>
            </div>

            {/* Mobile Navigation */}
            <div className="space-y-2">
              {[
                {
                  label: 'Biens', 
                  icon: 'buildings',
                  items: ['Liste des biens', 'Nouveau bien', 'Modifier/Consulter', 'Recherche avancée'],
                  key: 'biens'
                },
                {
                  label: 'Acquéreurs', 
                  icon: 'people',
                  items: ['Annuaire complet', 'Nouveau contact', 'Demandes de contact', 'Recherche contacts', 'Import/Export'],
                  key: 'contacts'
                },
                {
                  label: 'Documents', 
                  icon: 'file-earmark-pdf',
                  items: ['Mes documents', 'Générer nouveau', 'Modèles', 'Archives'],
                  key: 'documents'
                },
                {
                  label: 'Marketing', 
                  icon: 'megaphone',
                  items: ['Dashboard', 'Réseaux sociaux', 'Campagnes', 'Analytics', 'Chatbot'],
                  key: 'marketing'
                },
                {
                  label: 'Outils', 
                  icon: 'tools',
                  items: ['Calculatrices', 'Statistiques', 'Rapports', 'Exports'],
                  key: 'outils'
                },
                {
                  label: 'Impression', 
                  icon: 'printer',
                  items: ['Fiches biens', 'Documents légaux', 'Rapports de visite', 'Mandats'],
                  key: 'impression'
                },
                {
                  label: 'Aide', 
                  icon: 'question-circle',
                  items: ['Documentation', 'Tutoriels', 'Support technique', 'Contact'],
                  key: 'aide'
                }
              ].map((item) => (
                <div key={item.key} className="border-b border-white/10 last:border-0">
                  <button
                    className="w-full text-left text-white/80 hover:text-white py-3 px-4 hover:bg-white/10 transition-colors flex items-center justify-between"
                    onClick={() => {
                      // Toggle submenu
                      if (mobileSubMenu === item.key) {
                        setMobileSubMenu(null);
                      } else {
                        setMobileSubMenu(item.key);
                      }
                    }}
                  >
                    <div className="flex items-center">
                      <i className={`bi bi-${item.icon} mr-3`}></i>
                      {item.label}
                    </div>
                    <i className={`bi bi-chevron-down transition-transform duration-200 ${mobileSubMenu === item.key ? 'rotate-180' : ''}`}></i>
                  </button>
                  
                  {/* Mobile Submenu */}
                  {mobileSubMenu === item.key && (
                    <div className="bg-white/5 py-2">
                      {item.items.map((subItem, index) => (
                        <button
                          key={index}
                          className="w-full text-left text-white/70 hover:text-white py-2 px-8 hover:bg-white/10 transition-colors text-sm"
                          onClick={() => {
                            // Handle submenu actions
                            if (item.key === 'biens' && subItem === 'Liste des biens') {
                              showPropertiesView();
                            } else if (item.key === 'biens' && subItem === 'Nouveau bien') {
                              startNewProperty();
                            } else if (item.key === 'contacts' && subItem === 'Annuaire complet') {
                              showContactsView();
                            } else if (item.key === 'contacts' && subItem === 'Demandes de contact') {
                              showDemandesContactView();
                              setIsMobileMenuOpen(false);
                            } else if (item.key === 'documents' && subItem === 'Mes documents') {
                              showDocumentsView();
                              setActiveDocumentsTab('mes-documents');
                            } else if (item.key === 'documents' && subItem === 'Générer nouveau') {
                              showDocumentsView();
                              setActiveDocumentsTab('generer');
                            } else if (item.key === 'documents' && subItem === 'Modèles') {
                              showDocumentsView();
                              setActiveDocumentsTab('modeles');
                            } else if (item.key === 'documents' && subItem === 'Archives') {
                              showDocumentsView();
                              setActiveDocumentsTab('archives');
                            } else if (item.key === 'documents') {
                              showDocumentsView();
                              setActiveDocumentsTab('mes-documents');
                            } else if (item.key === 'marketing' && subItem === 'Dashboard') {
                              showMarketingView();
                              setActiveMarketingTab('dashboard');
                            } else if (item.key === 'marketing' && subItem === 'Réseaux sociaux') {
                              showMarketingView();
                              setActiveMarketingTab('social');
                            } else if (item.key === 'marketing' && subItem === 'Campagnes') {
                              showMarketingView();
                              setActiveMarketingTab('campaigns');
                            } else if (item.key === 'marketing' && subItem === 'Analytics') {
                              showMarketingView();
                              setActiveMarketingTab('analytics');
                            } else if (item.key === 'marketing' && subItem === 'Chatbot') {
                              showMarketingView();
                              setActiveMarketingTab('chatbot');
                            } else if (item.key === 'marketing') {
                              showMarketingView();
                              setActiveMarketingTab('dashboard');
                            }
                            setIsMobileMenuOpen(false);
                            setMobileSubMenu(null);
                          }}
                        >
                          {subItem}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Backdrop for dropdowns */}
      {activeDropdown && (
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setActiveDropdown(null)}
        />
      )}
    </header>
  );
};

export default Header;
